module.exports = __webpack_public_path__ + "media/images/badges/purebarre/PureBarre-7000-Classes-Inactive-99ab3eeb1522b923cd90f678bd20c2e0.png";